module.exports = __webpack_public_path__ + "front/img/slogan01.275df2c9.png";